import TemplateModel from "./TemplateModel"
const SmsTemplateModel = new TemplateModel("sms")
export default SmsTemplateModel